type FontLoadStrategy = 'auto' | 'block' | 'swap' | 'fallback' | 'optional'

const fontFaceRegex = new RegExp('@font-face.*?font-family:\\s?["\']([^"\']*?)["\'].*?\\}', 'gms')
export const patchFontDisplay = (
	fontDisplay: FontLoadStrategy,
	fontFamilyToFontFaces: Record<string, Array<string>>
): Record<string, Array<string>> => {
	const patchedFonts = { ...fontFamilyToFontFaces }
	Object.keys(patchedFonts).forEach((font) => {
		patchedFonts[font] = patchedFonts[font].map((fontString) =>
			fontString.replace(/[ \t]*font-display:[^;]*;\n?/, '').replace('}', `font-display: ${fontDisplay};\n}`)
		)
	})
	return patchedFonts
}

export const parseFontFaces = (cssString: string) => {
	let match
	const tahat: Record<string, Array<string>> = {}
	// eslint-disable-next-line no-cond-assign
	while ((match = fontFaceRegex.exec(cssString)) !== null) {
		const fontFamily = match[1].toLowerCase()
		tahat[fontFamily] = tahat[fontFamily] || []
		tahat[fontFamily].push(match[0])
	}
	return tahat
}
